<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { NXGDSButton, NXGDSButtonVariants } from '@nsftx/seven-nxg-design-system'
import type { CmsShortcutAction } from '@nsftx/seven-client-retail-vue-sgp'
import { useWidgetsStore } from '@/stores/widgets/widgetsStore'

interface FooterAction {
  name: string
  variant: NXGDSButtonVariants
  onClick: () => void
  shortcut?: CmsShortcutAction
}

const route = useRoute()

const widgetsStore = useWidgetsStore()
const { toggleLatestBetslips, toggleShortcuts, toggleCalculator } = widgetsStore
const {
  isLatestTicketsWidgetSelected,
  isShortcutsWidgetSelected,
  isCalculatorWidgetSelected,
  hideWidgets,
} = storeToRefs(widgetsStore)

const getButtonVariant = (isButtonActive: boolean) =>
  isButtonActive ? NXGDSButtonVariants.outlined : NXGDSButtonVariants.secondary

const isWidgetIconSelected = (isWidgetSelected: boolean) => isWidgetSelected && !hideWidgets.value

const footerActions = computed<FooterAction[]>(() => {
  const baseIcons = [
    {
      name: 'message',
      variant: getButtonVariant(false),
      onClick: () => {},
    },
    {
      name: 'megaphone',
      variant: getButtonVariant(false),
      onClick: () => {},
    },
  ]

  switch (route.name) {
    case 'login':
      return [
        {
          name: 'clock',

          variant: getButtonVariant(false),
          onClick: () => {},
        },
      ]
    case 'home':
      return [
        ...baseIcons,
        {
          name: 'betslips-ng',

          variant: getButtonVariant(false),
          onClick: () => {},
        },
        {
          name: 'question',

          variant: getButtonVariant(false),
          onClick: () => {},
        },
      ]
    case 'game':
      return [
        ...baseIcons,
        {
          name: 'betslips-ng',

          variant: getButtonVariant(isWidgetIconSelected(isLatestTicketsWidgetSelected.value)),
          onClick: () => {
            toggleLatestBetslips()
          },
        },
        {
          name: 'keyboard',

          variant: getButtonVariant(isWidgetIconSelected(isShortcutsWidgetSelected.value)),
          onClick: () => {
            toggleShortcuts()
          },
          shortcut: 'OPEN_SHORTCUTS_MODAL',
        },
        {
          name: 'calculator-ng',

          variant: getButtonVariant(isWidgetIconSelected(isCalculatorWidgetSelected.value)),
          onClick: () => {
            toggleCalculator()
          },
        },
      ]
    default:
      return baseIcons
  }
})
</script>

<template>
  <NXGDSButton
    v-for="action in footerActions"
    :key="action.name"
    :variant="action.variant"
    :icon="action.name"
    @click="action.onClick"
    @keydown.enter.prevent="action.onClick"
    v-shortcut="action.shortcut"
  />
</template>
